import { useCallback, useEffect, useState } from "react";
import { Alert, FormControlLabel, Paper, Stack, Switch, Typography } from "@mui/material";

/**
 * The takeover switch. On, this app's agent answers texts on the hourly
 * timer, as this app and inside its reviewed manifest. Both facts somebody
 * flipping this needs — "up to an hour", "it sends from your number" — are
 * said on the control itself, not in a footer.
 */
export default function TakeoverPanel({ own }) {
  const [state, setState] = useState(null);
  const [failure, setFailure] = useState(null);

  const load = useCallback(async () => {
    try {
      setState(await own("/takeover"));
      setFailure(null);
    } catch (e) {
      setFailure(e);
    }
  }, [own]);

  useEffect(() => {
    load();
  }, [load]);

  async function toggle(enabled) {
    try {
      setState(await own("/takeover", { method: "PUT", body: JSON.stringify({ enabled }) }));
    } catch (e) {
      setFailure(e);
    }
  }

  return (
    <Paper variant="outlined" sx={{ p: 2 }}>
      <Stack spacing={1}>
        <FormControlLabel
          control={
            <Switch
              checked={Boolean(state?.enabled)}
              disabled={!state}
              onChange={(e) => toggle(e.target.checked)}
              slotProps={{ input: { "aria-label": "let the agent reply for me" } }}
            />
          }
          label={state?.enabled ? "Agent is replying for you" : "Agent is off"}
        />
        <Typography variant="body2" color="text.secondary">
          While this is on, the agent answers unanswered texts once an hour, as this app and only within what its
          manifest allows. A reply can be up to an hour late.
        </Typography>
        {failure ? (
          <Alert severity="error" variant="outlined">
            The switch could not be {state ? "changed" : "read"}.
          </Alert>
        ) : null}
      </Stack>
    </Paper>
  );
}
